"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCartEventObject = void 0;
const isDeliverySalesOrderItem_1 = require("../isDeliverySalesOrderItem");
const createCartEventObject = (salesOrderItems, totalPrice) => ({
    currency: "AUD",
    items: salesOrderItems
        // don't show delivery in the list of products
        .filter((salesOrderItem) => !(0, isDeliverySalesOrderItem_1.isDeliverySalesOrderItem)(salesOrderItem, env.deliveryId))
        .map((salesOrderItem) => ({
        item_id: salesOrderItem.productId,
        item_name: salesOrderItem.title,
        item_category: salesOrderItem.category.label,
        price: salesOrderItem.price,
        quantity: salesOrderItem.quantity
    })),
    value: totalPrice
});
exports.createCartEventObject = createCartEventObject;
//# sourceMappingURL=createCartEventObject.js.map